export default function Textarea({
  label,
  rows = 4,
  placeholder,
  value,
  onChange,
  error,
  helperText,
  className = '',
  id,
  name,
  style,
  inputStyle,
  ...props
}) {
  return (
    <div className={`form-group ${className}`} style={style}>
      {label && (
        <label className="lab-medium" htmlFor={id || name}>
          {label}
        </label>
      )}
      <textarea
        id={id || name}
        name={name}
        rows={rows}
        className={`input-field textarea ${error ? 'error' : ''}`}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        style={inputStyle}
        {...props}
      />
      {error ? (
        <span className="form-hint form-hint--error">{error}</span>
      ) : helperText ? (
        <span className="form-hint form-hint--helper">{helperText}</span>
      ) : null}
    </div>
  );
}
